

<template>
 	<div class="page-title-ui">
		<div class="page-title" :style="style">{{datas.title}}
      <div class="all" v-if="datas.showAll" @click="goUrl(datas.link)">全部<i class="icongengduo1 iconfont"></i></div>
    </div>
	</div>
</template>

<script>
// 标题

export default {
  name: "Title",
  props: {
    datas: Object
  },
  computed: {
    style() {
      var style = `font-weight:${this.datas.fontWeight};width:${this.datas.width/37.5}rem;font-family:${this.datas.fontFamily};height:${this.datas.height/37.5}rem;line-height:${this.datas.height/37.5}rem;text-align:${this.datas.position};color:${this.datas.color};font-size:${this.datas.fontSize};`
      if(this.datas.backType=='color'){
        style += `background-color:${this.datas.backgroundColor};`
      }
      if(this.datas.backType=='img'){
        style += `background-position:${this.datas.position};background-size:${this.datas.width/37.5}rem ${this.datas.height/37.5}rem;background-image:url(${this.datas.backgroundPic});`
      }
      return style
			
    }
  },
};
</script>

<style lang="less">
.page-title-ui{
		display: flex;
		justify-content: center;
		.page-title {
      position: relative;
      padding: 0 0.4rem;
      box-sizing: border-box;
			text-align: center;
			font-size: 18px;
			background-repeat: no-repeat;
			.all{
				display: flex;
				align-items: center;
				position: absolute;
				right: 0.4rem;
				top: 50%;
				font-size: 13px;
				transform: translateY(-50%);
				font-weight: bold;
				i{
					font-size: 13px;
					margin-left: 0.08rem;
					font-weight: bold;
				}
				
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Title.vue